import { getSessionStorage } from './browserStorageHandler';
import { ACTIVE_PARTNER_SUBSCRIPTIONS } from './constants/localStorageConstants';

export interface PartnerDetails {
  content_partner_id?: number;
  content_partner_name?: string;
  partnerId?: string;
}

export const getActivePartnerSubscriptions = () => {
  return getSessionStorage(ACTIVE_PARTNER_SUBSCRIPTIONS)?.toLowerCase() || '';
};
export const getContentOwner = (partnerDetails: PartnerDetails) => {
  let contentOwner = 'Zee5';
  if (
    partnerDetails &&
    Object.keys(partnerDetails).length &&
    partnerDetails?.content_partner_id
  ) {
    contentOwner = partnerDetails?.content_partner_name || '';
  }
  return contentOwner;
};
export function isUserSubscribedToPartnerCheck(
  subscriptions: any = [],
  contentPartnerDetails = {}
) {
  let isUserSubscribed = false;
  const partnerDetails: PartnerDetails = contentPartnerDetails;
  if (subscriptions?.length) {
    subscriptions.forEach((subscription: any) => {
      if (isUserSubscribed) {
        return isUserSubscribed;
      }
      if (subscription && Object.keys(subscription).length) {
        const contentPartnerDetailsArr =
          subscription?.subscription_plan?.content_partner_details;
        if (contentPartnerDetailsArr?.length) {
          isUserSubscribed = !!contentPartnerDetailsArr.find(
            (partner: any) =>
              partner?.content_partner_id ===
              (partnerDetails?.content_partner_id || partnerDetails?.partnerId)
          );
        }
      }
      return null;
    });
  }
  return isUserSubscribed;
}
